import React from 'react';
import { Tooltip, IconButton, Box, Avatar } from '@mui/material';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { OFFICE_HOME, OFFICE_MEMBERS, OFFICE_SETTINGS, OFFICES } from '../routes/routes';
import { tokens } from '../theme/tokens';
import { useOffice } from '../store/officeContext';

const buildPath = (pattern, officeId) => pattern.replace(':officeId', officeId);
const RAIL_WIDTH = 76;

const OfficeRail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { officeId } = useParams();
  const { office } = useOffice();

  const homePath = buildPath(OFFICE_HOME, officeId);
  const onHomeRoute = location.pathname === homePath;

  const NAV_ITEMS = [
    { label: 'Panel', icon: DashboardRoundedIcon, active: onHomeRoute, onClick: () => navigate(homePath) },
    { label: 'Miembros', icon: GroupRoundedIcon, active: location.pathname === buildPath(OFFICE_MEMBERS, officeId), onClick: () => navigate(buildPath(OFFICE_MEMBERS, officeId)) },
  ];

  return (
    <Box
      component="nav"
      sx={{
        width: RAIL_WIDTH, flex: `0 0 ${RAIL_WIDTH}px`, height: '100vh',
        position: 'sticky', top: 0, display: 'flex', flexDirection: 'column',
        alignItems: 'center', gap: 0.75, py: 2.5,
        backgroundColor: 'rgba(255,255,255,.75)',
        borderRight: `1px solid ${tokens.colors.line}`,
        backdropFilter: 'blur(14px)',
      }}
    >
      <Tooltip title="Volver a mis despachos" placement="right" arrow>
        <IconButton
          onClick={() => navigate(OFFICES)}
          sx={{
            width: 42, height: 42, borderRadius: `${tokens.radius.md + 1}px`, mb: 2,
            color: tokens.colors.muted,
            '&:hover': { backgroundColor: tokens.colors.panel2, color: tokens.colors.txt },
          }}
        >
          <ArrowBackRoundedIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>

      {NAV_ITEMS.map(({ label, icon: Icon, active, onClick }) => (
        <Tooltip key={label} title={label} placement="right" arrow>
          <IconButton
            onClick={onClick}
            sx={{
              width: 46, height: 46, borderRadius: `${tokens.radius.md + 2}px`,
              color: active ? tokens.colors.txt : tokens.colors.muted,
              backgroundImage: active ? tokens.gradient.soft : 'none',
              position: 'relative',
              '&:hover': { backgroundColor: active ? undefined : tokens.colors.panel2, color: tokens.colors.txt },
              '&::before': active ? {
                content: '""', position: 'absolute', left: -20, top: 12, bottom: 12,
                width: 3, borderRadius: '4px', backgroundImage: tokens.gradient.main,
              } : undefined,
            }}
          >
            <Icon sx={{ fontSize: 21 }} />
          </IconButton>
        </Tooltip>
      ))}

      <Box sx={{ flex: 1 }} />

      <Tooltip title="Configuración del despacho" placement="right" arrow>
        <IconButton
          onClick={() => navigate(buildPath(OFFICE_SETTINGS, officeId))}
          sx={{
            width: 40, height: 40, borderRadius: `${tokens.radius.sm + 3}px`,
            color: location.pathname === buildPath(OFFICE_SETTINGS, officeId) ? tokens.colors.txt : tokens.colors.muted,
            '&:hover': { backgroundColor: tokens.colors.panel2, color: tokens.colors.txt },
          }}
        >
          <SettingsRoundedIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>

      <Avatar
        variant="rounded"
        src={office?.icon_url || undefined}
        sx={{
          width: 40, height: 40, mt: 0.5, borderRadius: `${tokens.radius.sm}px`,
          fontWeight: 700, fontSize: 13, color: '#0a0b10', backgroundImage: tokens.gradient.main,
        }}
      >
        {office?.name?.charAt(0).toUpperCase() || '?'}
      </Avatar>
    </Box>
  );
};

export default OfficeRail;
export { RAIL_WIDTH };